import moment from 'moment';
import {paymentType} from '../types/paymentTypes';

export const mapCardPaymentNoCardData = (insuranceId, cashflowId, shipmentDetails, isStoreCard) => {
    const expiryYear  = moment().add(6, 'y').format('YYYY');
    const expiryMonth = moment().add(1, 'months').format('MM');

    return {
        insuranceId       : insuranceId || 0,
        cashflowId        : cashflowId || 1,
        cardId            : null,
        deviceDateTime    : moment().format(),
        deliveryAddressId : shipmentDetails?.deliveryAddress?.addressId,
        receiverName      : shipmentDetails?.receiverName,
        receiverPhone     : shipmentDetails?.receiverPhone,
        receiverAddInfo   : shipmentDetails?.receiverAddInfo,
        paymentType       : paymentType.vposInsurance, // "VPOS_INSURANCE", 
        cardData          : {
            pan         : null,
            nameOnCard  : null,
            cvcCode     : null,
            expiryYear,
            expiryMonth,
            storeCard   : isStoreCard ? true : false
        }
    }
}

export const mapCardPaymentWithCardData = (card, insuranceId, cashflowId, shipmentDetails, isStoreCard) => {
    // const expiryYear  = moment().add(6, 'y').format('YYYY');
    // const expiryMonth = moment().add(1, 'months').format('MM');

    return {
        insuranceId       : insuranceId || 0,
        cashflowId        : cashflowId || 1,
        cardId            : card.cardId,
        deviceDateTime    : moment().format(),
        deliveryAddressId : shipmentDetails?.deliveryAddress?.addressId,
        receiverName      : shipmentDetails?.receiverName,
        receiverPhone     : shipmentDetails?.receiverPhone,
        receiverAddInfo   : shipmentDetails?.receiverAddInfo,
        paymentType       : paymentType.vposInsurance, // "VPOS_INSURANCE", 
        cardData          : {}
    }
}

export const mapCashOnDelivery = ( insuranceId, cashflowId, shipmentDetails) => {
    // const expiryYear  = moment().add(6, 'y').format('YYYY');
    // const expiryMonth = moment().add(1, 'months').format('MM');

    return {
        insuranceId       : insuranceId || 0,
        cashflowId        : cashflowId || 1,
        cardId            : null,
        deviceDateTime    : moment().format(),
        deliveryAddressId : shipmentDetails?.deliveryAddress?.addressId,
        receiverName      : shipmentDetails?.receiverName,
        receiverPhone     : shipmentDetails?.receiverPhone,
        receiverAddInfo   : shipmentDetails?.receiverAddInfo,
        paymentType       : paymentType.cashOnDelivery, // "CASH_ON_DELIVERY",
        cardData          : {}
    }
}